import styled from 'styled-components/macro';

import { variant, compose } from 'styled-system';
import Icon from '../Icon';

/**
 * Close
 */
const Close = styled(Icon).attrs(
  compose(variant({ scale: 'notifications.closeButton.variantMap' })),
)`
  flex-shrink: 0;
  appearance: none;
  display: flex;
  cursor: pointer;
  background-color: transparent;
  border: none;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
`;

Close.displayName = 'NotificationCloseButton';

export default Close;
